import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { Button, buttonVariants } from '@/shared/ui';

interface OrderInquiryPageNoticeProps {
  readonly message: string;
  readonly link?: { readonly to: string; readonly label: string };
  readonly onRetry?: () => void;
}

/** 교환·환불 문의 접수 화면이 폼 대신 보여 주는 한 줄 안내 — 접수할 수 없는 이유, 불러오기 실패. */
export const OrderInquiryPageNotice = ({
  message,
  link,
  onRetry,
}: OrderInquiryPageNoticeProps): ReactElement => (
  <div role="alert" className="flex max-w-2xl flex-col items-start gap-4 text-sm">
    <p className="text-muted-foreground">{message}</p>
    {link !== undefined && (
      <Link to={link.to} className={buttonVariants({ variant: 'outline', size: 'sm' })}>
        {link.label}
      </Link>
    )}
    {onRetry !== undefined && (
      <Button type="button" variant="outline" size="sm" onClick={onRetry}>
        다시 시도
      </Button>
    )}
  </div>
);
